
function GetSuggestedProducts() {
    if ($("#CurCatalogID").length > 0 && $(".AutoGetSuggested").length > 0) {
        $.ajax({
            type: "GET",
            url: getRequestRoute() + "/p/ProductDetails/GetSuggestedProducts",
            data: "ProductID=" + $("#ProductID").val() + "&CurCatalogID=" + $("#CurCatalogID").val() + "&ColorID=" + $(".Colors .ColorOptionItem.active:first a").attr("data-id"),
            cache: false,
            success: function (dt) {
                dt = dt.replace("_buyuk", "_kucuk");
                $(".AutoGetSuggested .AutoSetted").remove();

                if (dt != "") {
                    $(".AutoGetSuggested").append(dt);
                    $(".AutoGetSuggested .Productsuggest .ProductList").addClass("col-xs-24");
                }
            }
        });
    }
}

function SetLastVisitedProductsStorage() {
    var LastVisitedPrds = [];
    var lastPrdsKey = "LastVisitedPrds-" + $("#SmallCountryCode").val() + "-" + $("#SmallLangCode").val();

    if (typeof (Storage) !== "undefined") {
        if ($(".ProductHeader:first").length > 0 || $(".AutoGetLastVisited").length > 0) {
            var hours = 8; // Reset when storage is more than 24hours
            var now = new Date().getTime();
            var setupTime = localStorage.getItem('prdLastSetupTime');

            if (setupTime == null) {
                localStorage.setItem('prdLastSetupTime', now);
            } else {
                if (now - setupTime > hours * 60 * 60 * 1000) {
                    localStorage.removeItem(lastPrdsKey);
                    localStorage.setItem('prdLastSetupTime', now);
                }
            }

            var _productid = $("#ProductID:first").val();
            var _colorid = $("#ColorID:first").val();
            var _url = window.location.pathname;
            var _prdImg = $("#FirstAngle:first").val();//$("meta[property$=image]").attr("content");
            var _prdname = $(".ProductHeader:first").text();
            var _amount = $(".PriceItem:first").text();

            _prdname = _prdname.replace(/(\r\n|\n|\r)/gm, "").trim();

            LastVisitedPrds = GetLastVisitedData();

            var itemExist = false;

            for (var i = 0; i < LastVisitedPrds.length; i++) {
                if (LastVisitedPrds[i].ColorID == _colorid && LastVisitedPrds[i].ProductID == _productid) {
                    itemExist = true;
                }
            }

            if (!itemExist) {
                LastVisitedPrds.push({ Amount: _amount, ProductID: _productid, ColorID: _colorid, Url: _url, Img1: _prdImg, Img2: _prdImg, ProductName: _prdname });

                if (LastVisitedPrds.length > 6) {
                    LastVisitedPrds.shift();
                }

                localStorage.setItem(lastPrdsKey, JSON.stringify(LastVisitedPrds));
            }
        }
    }
}

function SlickSlider(SuggestedSlick) {
    var rtl = false;

    if ($("#SmallLangCode").val() == "ar") {
        rtl = true;
    }

    if (SuggestedSlick == "suggested") {
        if ($(".SuggestedProductsContainer.LastVisited .SuggestedProducts .ProductList .Prd").length > 3) {
            $(".SuggestedProductsContainer.LastVisited .SuggestedProducts .ProductList").slick({
                nextArrow: "<div class='PrdImgRight right-arrow'><i class='sorsfont sorsfont-right'></i></div>",
                prevArrow: "<div class='PrdImgLeft left-arrow'><i class='sorsfont sorsfont-left'></i></div>",
                infinite: true,
                slidesToShow: 3,
                slidesToScroll: 1,
                lazyLoad: 'ondemand',
                arrows: true,
                rtl: rtl,
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            infinite: true,
                            dots: true
                        }
                    }
                ]
            });
        }
        else {
            $(".UseLazyLoadSuggested").Lazy();
        }
    }
    else if (SuggestedSlick == "main") {
        UseSliderObject = "";

        if ($("#NewPd").hasClass("Combines")) {
            UseSliderObject = $('.ProductDetailImages ul');
        }
        else {
            UseSliderObject = $('.ProductDetailsMainImage ul');
        }

        // Main Slider
        UseSliderObject.slick({
            nextArrow: "<div class='PrdImgRight right-arrow'><i class='sorsfont sorsfont-right'></i></div>",
            prevArrow: "<div class='PrdImgLeft left-arrow'><i class='sorsfont sorsfont-left'></i></div>",
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            lazyLoad: 'ondemand',
            rtl: rtl,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: true
                    }
                }
            ]
        });

        $('.SmallProductImages ul').slick({
            slidesToShow: 5,
            slidesToScroll: 1,
            asNavFor: UseSliderObject,
            focusOnSelect: true,
            rtl: rtl
        });

    }
    else if (SuggestedSlick == "combine") {
        if ($(".SuggestedProductsContainer.CombineProduct .SuggestedProducts .ProductList .Prd").length > 3) {
            $(".SuggestedProductsContainer.CombineProduct .SuggestedProducts .ProductList").slick({
                nextArrow: "<div class='PrdImgRight right-arrow'><i class='sorsfont sorsfont-right'></i></div>",
                prevArrow: "<div class='PrdImgLeft left-arrow'><i class='sorsfont sorsfont-left'></i></div>",
                infinite: true,
                slidesToShow: 3,
                slidesToScroll: 1,
                //lazyLoad: 'ondemand',
                arrows: true,
                rtl: rtl,
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            infinite: true,
                            dots: true
                        }
                    }
                ]
            });
        }
        //else if ($(".SuggestedProductsContainer.CombineProduct .SuggestedProducts .ProductList .Prd").length > 0) {
        //    $(".SuggestedProductsContainer.CombineProduct .SuggestedProducts .ProductList .Prd").each(function () {
        //        $(this).find(".PImage").attr("src", $(this).find(".PImage").attr("data-lazy"));
        //    });
        //}
    }

    if (SuggestedSlick == "search") {
        if ($(".searchArea .SuggestedProductsContainer .AutoGetLastVisited .SuggestedProducts .ProductList .Prd").length > 3) {
            $(".searchArea .SuggestedProductsContainer .AutoGetLastVisited .SuggestedProducts .ProductList").slick({
                nextArrow: "<div class='PrdImgRight right-arrow'><i class='sorsfont sorsfont-right'></i></div>",
                prevArrow: "<div class='PrdImgLeft left-arrow'><i class='sorsfont sorsfont-left'></i></div>",
                infinite: true,
                slidesToShow: 4,
                slidesToScroll: 1,
                //lazyLoad: 'ondemand',
                arrows: true,
                rtl: rtl,
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            infinite: true,
                            dots: true
                        }
                    }
                ]
            });
        }
        else {
            $(".searchArea .SuggestedProductsContainer .AutoGetLastVisited .SuggestedProducts .ProductList .UseLazyLoadSuggested").each(function () {
                var img = $(this).attr("data-lazy");
                if (img != null && img != "" && img != undefined) {
                    $(this).attr("src", img);
                }
            });
        }
    }
}

$(document).ready(function () {
    IsfollowForProductDetails();
    GetSuggestedProducts();

    SlickSlider("combine");

    if (isMobileResolution()) {

    }
    SlickSlider("main");

    if (!isMobileResolution()) {
        $(".UseLazyLoadDetail").Lazy();

        //$(document).on("mouseover", ".ProductDetailsMainImage ul li", function () {
        //    useImage = $(this).find("img");

        //    var Imagesort = useImage.attr("data-sort");

        //    if (!$(".zoomContainer").hasClass(Imagesort)) {
        //        var ImageUrl = useImage.attr("src");
        //        useImage.attr("src", ImageUrl);

        //        //useImage.ezPlus({
        //        //    cursor: 'crosshair',
        //        //    scrollZoom: true,
        //        //    zoomType: 'inner'
        //        //});

        //        setTimeout(function () {
        //            $(".zoomContainer:last").addClass(Imagesort);
        //        }, 200);                
        //    }            
        //});

        // Zoom miktarının sıfırlanması
        //$(document).on("mouseout", ".zoomContainer", function () {
        //    var Imagesort = $(this).attr("class");
        //    Imagesort = Imagesort.replace("zoomContainer ", "");
        //    Imagesort = parseInt(Imagesort);

        //    if (typeof Imagesort == "number" && !isNaN(Imagesort) && Imagesort != undefined) {
        //        $(".zoomContainer." + Imagesort).remove();
        //    }            
        //});
    }


    //if ($("body").hasClass("productdetails") && $("#CName").val() == "ProductDetails" && $("#AName").val() == "Index") {
    //    SetLastVisitedProductsStorage();

    //    var LastVisitedPrds = GetLastVisitedData();

    //    if (LastVisitedPrds != undefined && LastVisitedPrds.length > 0) {
    //        GetLastVisitedPrdView(LastVisitedPrds, function (dt) {
    //            if (dt != "") {
    //                $(".SuggestedProductsContainer.LastVisited .AutoGetLastVisited").append(dt);

    //                if ($(".productdetails .SuggestedProductsContainer .AutoGetLastVisited .SuggestedProducts").length > 0) {
    //                    SlickSlider("suggested");

    //                    //if (!isMobileResolution()) {
    //                    //    $(".UseLazyLoadSuggested").Lazy();
    //                    //}
    //                }
    //            }
    //        });
    //    }
    //}

    // To Operations
    $('.PdInstallmentOptions, .PrInstallmentOptions').live("click", function (e) {
        var Amount = $(".PriceItem:first").html();
        GetProductInstalments(Amount);
    });

    // SEPETE EKLE
    $(".AddToBasket.ProductDetails #Basket").live("click", function (e) {
        var SizeID = $("#SizeID").val();
        var ColorID = $("#ColorID").val();
        var ProductID = $("#ProductID").val();
        var Amount = 1;
        var LangID = $("#LangID").val();
        var BedenSec = $('#BedenSec').val();
        var RenkSec = $('#RenkSec').val();
        var UrunYok = $('#UrunYok').val();

        $basketButton = $(this);
        $basketButton.prop("disabled", true);

        if (SizeID != undefined && ColorID != undefined && ProductID != undefined && SizeID != "" && ColorID != "" && ProductID != "") {
            var NormalText = $basketButton.text();
            var AddingText = $basketButton.attr("data-adding");
            $basketButton.text(AddingText);

            var data = 'sizeID=' + SizeID + "&colorID=" + ColorID + "&productID=" + ProductID + "&adet=" + Amount + "&langID=" + LangID;

            GenerateLocalLoading($(".ProductDetail"), "show");
            //$(".backdrop").addClass("active");
            AddToCard(data, function (dt) {
                $basketButton.text(NormalText);

                if (dt.Sonuc == true) {

                    if (dt.JsonRs != '' && dt.JsonRs != null && dt.JsonRs != undefined) {

                        //#region DataLayer
                        var _dataLayerJSON = ExtractJSONFromString(dt.JsonRs, 'DataLayer');
                        console.log("_dataLayerJSON:", _dataLayerJSON);

                        if (_dataLayerJSON != null && _dataLayerJSON != undefined && _dataLayerJSON != "") {

                            window.dataLayer = window.dataLayer || [];
                            dataLayer.push({
                                "event": "eec.add",
                                "ecommerce": {
                                    "add": {
                                        "actionField": {
                                            "list": "Product Detail"
                                        },
                                        "products": [_dataLayerJSON]
                                    }
                                }
                            });

                            //dataLayer.push(JSON.parse(_dataLayerJSON));
                        }
                        //#endregion DataLayer

                        //#region Klaviyo
                        var _klaviyoJSON = ExtractJSONFromString(dt.JsonRs, 'Klaviyo');
                        console.log("_klaviyoJSON:", _klaviyoJSON);

                        if (_klaviyoJSON != null && _klaviyoJSON != undefined && _klaviyoJSON != "") {
                            klaviyo.push(["track", "Added to Cart", _klaviyoJSON]);
                        }
                        //#endregion Klaviyo
                    }

                    GetSepetIcerik(function (dt) {
                        $("#UserAndBasket").html(dt);

                        //if (!isMobileResolution() {
                        //    toggleBasket();
                        //}

                        toggleBasket();

                        // 5 sn. sonra kapansın                                
                        //setTimeout(function () {
                        //    if ($("body").hasClass("BasketDropped")) {
                        //        toggleBasket();
                        //    }
                        //}, 5000);
                    });
                }
                else {
                    SwalGenerate("error", dt.IslemSonucAciklama, getStandartMessages("Hata"), getStandartMessages("Kapat"));
                }

                GenerateLocalLoading($(".ProductDetail"), "hide");
                //$(".backdrop").removeClass("active");
                $basketButton.prop("disabled", false);
            });
        }
        else {
            if (SizeID == undefined || SizeID == "") {
                $(".backdrop").addClass("active");
                $(".SizeOptions").addClass("PleaseSelect");
                $(".AddToBasket").addClass("PleaseSelect");

                $(".ProductOptions").addClass("PleaseSelectFixedArea");

                //setTimeout(function () {
                //    $(".ProductOptions").addClass("PleaseSelectFixedArea");
                //}, 500);

                //if ($(window).width() > 767) {
                //    $(".ProductOptions").css("position", "unset");
                //    $("body").css("overflow", "hidden");
                //}

                var OptionAreaScrollTop = 0;
                if (isMobileResolution()) {
                    OptionAreaScrollTop = $(".SizeOptions").offset().top - 250;
                }

                $('html, body').animate({
                    scrollTop: OptionAreaScrollTop
                }, 500);

                if ($(".AutoTextRep").length > 0) {
                    $(".AddToBasket button").attr("data-first", $(".AddToBasket button").text());
                    $(".AddToBasket button").text($('#BedenSec').val());

                    $(".AddCombineToBasket button").attr("data-first", $(".AddCombineToBasket button").text());
                    $(".AddCombineToBasket button").text($('#BedenSec').val());
                }
            }

            if (ColorID == undefined || ColorID == "") {
                alert(RenkSec);

                $(".AddToBasket button").attr("data-first", $(".AddToBasket button").text());
                $(".AddCombineToBasket button").attr("data-first", $(".AddCombineToBasket button").text());

                if ($(".AutoTextRep").length > 0) {
                    $(".AddToBasket button").text($('#BedenSec').val());
                    $(".AddCombineToBasket button").text($('#BedenSec').val());
                }
            }

            if (ProductID == undefined || ProductID == "") alert(UrunYok);
        }

        e.preventDefault();

        return false;
    });

    //Ürün Beden Seçimi
    $('.SizeOptions a:not(.NotifyWhen)').live("click", function () {
        $(this).parents(".Sizes").find("#SizeID").val($(this).attr("data-id"));

        $(this).parents(".SizeOptions").find("a").removeClass("active");
        $(this).parents(".SizeOptions").find("span").removeClass("active");
        $(this).addClass("active");
        $(this).parent().addClass("active");

        if ($(".NewPD").length > 0) {
            $(".SizeOptions, .SizeAndAmount span.ChooseTitle").addClass("passed");
            $(".Colors span.ChooseTitle").removeClass("current");
            $(".Colors span.ChooseTitle").addClass("passed");

            $(".Sizes span.ChooseTitle").removeClass("current");
            $(".Sizes span.ChooseTitle").addClass("passed");

            $(".SizeAndAmount  > span.ChooseTitle").removeClass("current");
            $(".SizeAndAmount  > span.ChooseTitle").addClass("passed");

            $(".AmountOptions  span.ChooseTitle").removeClass("passed");
            $(".AmountOptions  span.ChooseTitle").addClass("current");

            var TrigAddBasket = false;

            if ($(".SizeOptions.PleaseSelect").length == 1) {
                TrigAddBasket = true;
            }

            $(".AddToBasket button").removeClass("NotSelected");

            if ($(".AutoTextRep").length > 0 && $(".AddToBasket button").attr("data-first") != undefined && $(".AddToBasket button").attr("data-first").length > 0 && $(".EsPD").length <= 0) {
                $(".AddToBasket button").text($(".AddToBasket button").attr("data-first"));
            }

            $(".SizeOptions").removeClass("PleaseSelect");
            $(".AddToBasket").removeClass("PleaseSelect");
            $(".ProductOptions").removeClass("PleaseSelectFixedArea");
            $(".AddToBasket.ProductDetails #Basket").prop("disabled", false);

            $(".backdrop").removeClass("active");

            if (TrigAddBasket) {
                $(".AddToBasket #Basket").click();
            }
        }
    });

    // Renk Değişimi
    //$("#changeColor").live("click", function (e) {
    //    var LangID = $("#LangID").val();
    //    var ProductID = $(this).attr("data-productID");
    //    var ColorID = $(this).attr("data-id");
    //    button = $(this);
    //    //alert("test Renk değis js");
    //    ChangeProductColor(ProductID, ColorID, LangID, function (data, status) {
    //        if (status == true && data != null && data != undefined && data != "") {

    //            // #region ProductImages
    //            if (isMobileResolution()) {
    //                $(".ProductDetailsMainImage > ul").slick('unslick');
    //            }

    //            $(".ProductDetailsMainImage > ul li").remove();

    //            if (data.ImagePath != null && data.ImagePath != undefined && data.ImagePath != "") {
    //                var Images = data.ImagePath.split(';');

    //                $.each(Images, function (k, v) {
    //                    $(".ProductDetailsMainImage > ul").append('<li class="ImgArea fancybox" href="' + v.replace("_enbuyuk", "_buyuk") + '"><img src="' + v.replace("_enbuyuk", "_buyuk") + '"  /></li>');
    //                });
    //            }

    //            if (isMobileResolution()) SlickSlider("main");
    //            // #endregion

    //            // #region ProductSizes
    //            $(".SizeOptions").html("");

    //            if ($(".SizeOptions #SelectSizePopup").length > 0) {
    //                selectSizePopup = $(".SizeOptions #SelectSizePopup").clone();
    //                $(".SizeOptions").append(selectSizePopup);
    //            }

    //            $(".SizeOptions").removeClass("passed");
    //            $("#SizeID").val("");

    //            if (data.Sizes != null && data.Sizes != undefined && data.Sizes != "") {
    //                var size = JSON.parse(data.Sizes);
    //                var newSizeCount = 0;

    //                $.each(size, function (k, v) {
    //                    var stil = "";

    //                    if (v.InStock == "false" || v.PStatus != "1") {
    //                        stil = "OutOfQuantity";

    //                        if ($(".NewPD").length > 0) {
    //                            $(".SizeOptions").append('<span class="outer">' +
    //                                ' <input type="hidden" name="SizeIDs" id="SizeIDs" value="' + v.ID + '" >' +
    //                                ' <span class="PdHint"> <span class="PdHint-content">Bu Ürünün ' + v.Name + ' Bedeni Stoklarla Kalmamıştır.<br />' +
    //                                '<a href="javascript:;" class="NotifyWhen">Ürün stoğa geldiğinde haber ver!</a>' +
    //                                ' </span><i class="reactangle"></i></span>'
    //                                + '<span class="inner">' + v.Name + '</span></span>');
    //                        } else {
    //                            $(".SizeOptions").append('<span class="outer"><span class="inner">' + v.Name + '</span></span>');
    //                        }
    //                    }
    //                    else {
    //                        $(".SizeOptions").append('<span><a data-id="' + v.ID + '" data-stock="' + v.InStock + '" data-name="' + v.Name + '" href="javascript:void(0)" class="' + stil + " " + v.Name + '">' + v.Name + '</a></span>');

    //                        newSizeCount++;
    //                    }
    //                });

    //                if (newSizeCount > 0) {
    //                    $(".AddToBasket").html("<button type='button' name='Basket' data-adding='" + getStandartMessages("LutfenBekleyin") + "' id='Basket' class='CartButtonColor NotSelected btn-theme-black'>" + $(".AddToBasketHidden").val() + "</button>");
    //                }
    //                else {
    //                    $(".AddToBasket").html("<span class='NotAvailableProduct'>" + $(".TukendiHidden").val() + "</span>");
    //                }
    //            }
    //            // #endregion

    //            $(".ProductHeader").html(data.ColorName + " " + data.ProductName);
    //            $(".ProductDetail .Colors .ColorThumb span").html(data.ColorName);
    //            document.title = data.ColorName + " " + data.ProductName;

    //            $(".Prices .PrdouctCode span").html(data.ProductCode);
    //            $(".PriceContainer .PriceOld").html(data.CurrencySymbol + " " + data.AmountOld.toFixed(2));
    //            $(".PriceContainer .Price ").html(data.CurrencySymbol + " " + data.Amount.toFixed(2));

    //            $(".Colors .ColorOption .active").removeClass("active");
    //            $(".AddToFavorite").attr("data-id", ProductID);
    //            button.parent().addClass("active");

    //            $("#PID").val(ProductID);
    //            $("#ProductID").val(ProductID);
    //            $("#ColorID").val(ColorID);
    //        }
    //        else {
    //            SwalGenerate("error", getStandartMessages("BirHataOlustu"), getStandartMessages("IslemBasarisiz"), getStandartMessages("Kapat"));
    //        }
    //    });
    //});

    // Favorilere Ekleme
    $(".passiveFavorite").live("click", function () {
        var ColorID = $("#ColorID").val();
        var ProductID = $("#ProductID").val();
        button = $(this);

        OverlayElement = $(".ProductDetail");
        if ($(window).width() < 992) {
            OverlayElement = $(".BasktButtons");
        }

        GenerateLocalLoading(OverlayElement, "show");

        if (ColorID != undefined && ProductID != undefined) {
            AddToFavorite(ColorID, ProductID, function (result, msg) {
                if (result == true) {
                    button.addClass("activeFavorite");
                    button.removeClass("passiveFavorite");
                    button.find(".sorsfont").removeClass("sorsfont-favorite").addClass("sorsfont-favorite-o");
                    SwalGenerate("success", "", getStandartMessages("IslemBasarili"), getStandartMessages("Kapat"));

                    setTimeout(function () {
                        if ($(".swal2-container .swal2-actions .swal2-confirm").length > 0) {
                            $(".swal2-container .swal2-actions .swal2-confirm").trigger("click");
                        }
                    }, 5000);
                }
                else {
                    var loginLink = getRequestRoute() + "/p/User/Login";

                    SwalGenerate("warning", msg, getStandartMessages("IslemBasarisiz"), "<a href='" + loginLink + "'>" + getStandartMessages("GirisYap") + "</a>");
                }

                GenerateLocalLoading(OverlayElement, "hide");
            });
        }
    });

    function BasketAddMessage() {
        Swal.fire({
            html: getStandartMessages(""),
            icon: "success",
            showCloseButton: true,
            confirmButtonText: "<a href='/tr/p/CheckOut/sepet?rf=sepet' style='color:#fff;font-weight:600;'>" + getStandartMessages("SiparisiTamamla") + "</a>",
            confirmButtonColor: "#a5dc86",
            showCancelButton: true,
            cancelButtonText: '<span style="color:#595959;font-weight:600">Alışverişe Devam Et</span>',
            cancelButtonColor: "#eaeaea"
        });
    }

    // Favorilerden Çıkarma
    $(".activeFavorite").live("click", function () {
        var ProductID = $("#ProductID").val();
        button = $(this);

        OverlayElement = $(".ProductDetail");
        if ($(window).width() < 992) {
            OverlayElement = $(".BasktButtons");
        }

        GenerateLocalLoading(OverlayElement, "show");

        if (ProductID != undefined) {
            removeFavorite(ProductID, function (result) {
                if (result == true) {
                    button.addClass("passiveFavorite");
                    button.removeClass("activeFavorite");
                    button.find(".sorsfont").removeClass("sorsfont-favorite-o").addClass("sorsfont-favorite");
                    SwalGenerate("success", "", getStandartMessages("IslemBasarili"), getStandartMessages("Kapat"));

                    setTimeout(function () {
                        if ($(".swal2-container .swal2-actions .swal2-confirm").length > 0) {
                            $(".swal2-container .swal2-actions .swal2-confirm").trigger("click");
                        }
                    }, 5000);
                }
                else {
                    SwalGenerate("error", getStandartMessages("BirHataOlustu"), getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
                }

                GenerateLocalLoading(OverlayElement, "hide");
            });
        }
    });

    // Stoğa Gelince Haber Ver Modal
    $("a.NotifyWhen").live("click", function myfunction() {
        var ProductID = $("#ProductID:first").val();
        var ColorID = $("#ColorID").val();
        var SizeID = $(this).parent().parent().parent().find("input[name=SizeIDs]").val();

        if (ProductID != "" && ProductID != null && ProductID != undefined && typeof ProductID !== 'undefined' && ColorID != null && ColorID != "" && ColorID != undefined && SizeID != null && SizeID != "" && SizeID != undefined) {
            var params = "ProductID=" + ProductID + "&ColorID=" + ColorID + "&SizeID=" + SizeID;
            GetListForRemind(params);
        }
    });

    // Stoğa Gelince Haber Action
    $("#NotifyModal #RemindMeLater.active").live("click", function myfunction() {
        var StockIDs = "?x=";
        var curVal = 0;

        $(".NotiyfyRow .OutOfStockRemind").each(function (index) {
            StockIDs += "&[" + curVal + "].StockID=" + $(this).attr("data-StockID");
            StockIDs += "&[" + curVal + "].SizeID=" + $(this).attr("data-sizeID");
            StockIDs += "&[" + curVal + "].ProductID=" + $(this).attr("data-ProductID");
            StockIDs += "&[" + curVal + "].ProductCode=" + $(this).attr("data-ProductCode");
            StockIDs += "&[" + curVal + "].ColorID=" + $(this).attr("data-colorid");

            curVal++;
        });

        var name = $('input[name="NameModal"]').val();
        var username = $('input[name="UserNameModal"]').val();

        var gsm = $('input[name="GsmModal"]').val();
        var gsmLen = 0;

        if (gsm != "" && gsm != null) {
            gsmLen = gsm.length;
        }

        //var kvkk = $('input[name="KVKKModal"]').prop("checked");
        var kvkk = true;

        if (kvkk == true && name != null && username != null && name != "" && username != "" && gsm != "") {
            if (gsmLen < 10) {
                SwalGenerate("error", getStandartMessages("GecerliTelefonNumarasi"), getStandartMessages("Hata"), getStandartMessages("TekrarDene"));
            }
            else {
                var param = StockIDs + "&Name=" + name + "&UserName=" + username + "&Gsm=" + gsm + "&kvkk=" + kvkk;
                RemindMeWhenAvailable(param);
            }
        }
        else {
            SwalGenerate("warning", getStandartMessages("LutfenTumAlanlariDoldurun"), getStandartMessages("Hata"), getStandartMessages("TekrarDene"));
        }

        return false;
    });
    // To Operations

    // Slider Setting
    $('.ProductDetailImages ul').on('afterChange', function (event, slick, currentSlide, nextSlide) {
        $(".SmallProductImages ul li").each(function () {
            if ($(this).data("slick-index") == currentSlide) {
                $("img", this).addClass("Selected");
            }
            else {
                $("img", this).removeClass("Selected");
            }
        });
    });

    // Image Zoom
    //$().fancybox({
    //    selector: '.fancybox'
    //});

    // Open SizeTable Modal
    $(".SizeTableLink").live("click", function () {
        $("#SizeTable").modal();
    });

    // Backdrop Setting
    $("body.productdetails .backdrop").on("click", function (e) {
        $(".backdrop").removeClass("active");

        $(".SizeOptions.open").removeClass("PleaseSelect");
        $(".SizeOptions, .CombineSizeOptions").removeClass("PleaseSelect");
        $(".AddToBasket.PleaseSelect").removeClass("PleaseSelect");

        $(".ProductOptions").removeClass("PleaseSelectFixedArea");
        $(".AddToBasket.ProductDetails #Basket").prop("disabled", false);

        if ($(".AutoTextRep").length > 0) {
            $(".AutoTextRep button").text($(".AutoTextRep button").attr("data-first"));
        }

        if (!isMobileResolution()) {
            $("body").css("overflow", "unset");
        }

        $("body").removeClass("no-scroll");
    });

    if ($(".SizeOptions .ONE.SIZE").length > 0) {
        $(".SizeOptions .ONE.SIZE").trigger("click");
    }
});